export const DateFormatter = new Intl.DateTimeFormat([navigator.language, 'en-GB'], {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
})
